<template>
   <div class="settings-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="settings-page-inner">
            <div class="settings-nav">
               <div class="settings-nav-list nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <button
                     v-if="roles.includes(15) && agencyUser"
                     :class="roles.includes(15) && agencyUser ? 'active' : ''"
                     class="settings-nav-list-item nav-link active"
                     id="nav-profile-tab"
                     data-bs-toggle="pill"
                     data-bs-target="#nav-profile"
                     type="button"
                     role="tab"
                     aria-controls="nav-profile"
                     aria-selected="true">
                     <!-- <i class="gts-icon icon-user-edit"></i> -->
                     <span class="settings-tabs-text">{{ $t("settings_profileSettings") }}</span>
                  </button>
                  <button
                     v-if="roles.includes(16)"
                     :class="!roles.includes(15) || (roles.includes(16) && !agencyUser) ? 'active' : ''"
                     class="settings-nav-list-item nav-link"
                     id="nav-user-authorization-tab"
                     data-bs-toggle="pill"
                     data-bs-target="#nav-user-authorization"
                     type="button"
                     role="tab"
                     aria-controls="nav-user-authorization"
                     aria-selected="true">
                     <!-- <i class="gts-icon icon-user-cog"></i> -->
                     <span class="settings-tabs-text">{{ $t("settings_userAuthorization") }}</span>
                  </button>

                  <button
                     v-if="roles.includes(27) && agencyUser"
                     :class="!roles.includes(15) && !roles.includes(16) && !roles.includes(17) && !roles.includes(18) && roles.includes(27) ? 'active' : ''"
                     class="settings-nav-list-item nav-link"
                     id="nav-commission-definition-tab"
                     data-bs-toggle="pill"
                     data-bs-target="#nav-commission-definition"
                     type="button"
                     role="tab"
                     aria-controls="nav-commission-definition"
                     aria-selected="true">
                     <!-- <i class="gts-icon icon-user-cog"></i> -->
                     <span class="settings-tabs-text">{{ $t("settings_userCommissionDefinition") }}</span>
                  </button>

                  <button
                     v-if="roles.includes(17) && agencyUser"
                     :class="!roles.includes(15) && !roles.includes(16) && roles.includes(17) && agencyUser ? 'active' : ''"
                     class="settings-nav-list-item nav-link"
                     id="nav-customer-tab"
                     data-bs-toggle="pill"
                     data-bs-target="#nav-customer"
                     type="button"
                     role="tab"
                     aria-controls="nav-customer"
                     aria-selected="false">
                     <!-- <i class="gts-icon icon-user-cog"></i> -->
                     <span class="settings-tabs-text">{{ $t("settings_customerManagement") }}</span>
                  </button>
                  <button
                     v-if="roles.includes(18)"
                     :class="!roles.includes(15) && !roles.includes(16) && !roles.includes(17) && roles.includes(18) ? 'active' : ''"
                     class="settings-nav-list-item nav-link"
                     id="nav-user-settings-tab"
                     data-bs-toggle="pill"
                     data-bs-target="#nav-user-settings"
                     type="button"
                     role="tab"
                     aria-controls="nav-user-settings"
                     aria-selected="false">
                     <!-- <i class="gts-icon icon-user-cog"></i> -->
                     <span class="settings-tabs-text">{{ $t("settings_userSettings") }}</span>
                  </button>
               </div>
               <div class="settings-nav-content-list tab-content" id="v-pills-tabContent">
                  <section
                     v-if="roles.includes(15) && agencyUser"
                     :class="[!roles.includes(15) && agencyUser ? 'active' : '', profileSettings ? 'active' : '']"
                     class="settings-nav-content-list-item tab-pane fade show"
                     id="nav-profile"
                     role="tabpanel"
                     aria-labelledby="nav-profile-tab">
                     <ProfileSettings @set-user-settings-obj="setUserSettingsObj" />
                  </section>
                  <section
                     v-if="roles.includes(16)"
                     :class="[!roles.includes(15) || (roles.includes(16) && !agencyUser) ? 'active' : '', userAuthorization ? 'active' : '']"
                     class="settings-nav-content-list-item tab-pane fade show"
                     id="nav-user-authorization"
                     role="tabpanel"
                     aria-labelledby="nav-user-authorization-tab">
                     <UserAuthorization />
                  </section>
                  <section
                     v-if="roles.includes(27)"
                     :class="[!roles.includes(15) && !roles.includes(16) && !roles.includes(17) && !roles.includes(18) && roles.includes(27) ? 'active' : '', commissionDefinition ? 'active' : '']"
                     class="settings-nav-content-list-item tab-pane fade show"
                     id="nav-commission-definition"
                     role="tabpanel"
                     aria-labelledby="nav-commission-definition-tab">
                     <CommissionDefinition />
                  </section>
                  <section
                     v-if="roles.includes(17) && agencyUser"
                     :class="[!roles.includes(15) && !roles.includes(16) && roles.includes(17) && agencyUser ? 'active' : '', customerManagement ? 'active' : '']"
                     class="settings-nav-content-list-item tab-pane fade show"
                     id="nav-customer"
                     role="tabpanel"
                     aria-labelledby="nav-customer-tab">
                     <CustomerManagement />
                  </section>
                  <section
                     v-if="roles.includes(18)"
                     :class="[!roles.includes(15) && !roles.includes(16) && !roles.includes(17) && roles.includes(18) ? 'active' : '', userSettings ? 'active' : '']"
                     class="settings-nav-content-list-item tab-pane fade show"
                     id="nav-user-settings"
                     role="tabpanel"
                     aria-labelledby="nav-user-settings-tab">
                     <UserSettings />
                  </section>
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";

import ProfileSettings from "@/pages/user/settings/ProfileSettings.vue";
import UserAuthorization from "@/pages/user/settings/UserAuthorization.vue";
import CommissionDefinition from "@/pages/user/settings/CommissionDefinition.vue";
import UserSettings from "@/pages/user/settings/UserSettings.vue";
import CustomerManagement from "@/components/structural/flight/common/CustomerManagement.vue";

export default {
   name: "SettingsPage",
   components: {
      Aside,
      Navbar,
      Main,
      ProfileSettings,
      UserAuthorization,
      CommissionDefinition,
      UserSettings,
      CustomerManagement,
   },
   data() {
      return {
         userObj: {},
         roles: [],
         agencyUser: true,
         profileSettings: false,
         userAuthorization: false,
         commissionDefinition: false,
         customerManagement: false,
         userSettings: false,
      };
   },
   created() {
      this.roles = JSON.parse(localStorage.getItem("auths"));
      if (this.$store.state.user.user.onBehalfOfs && this.$store.state.user.user.onBehalfOfs.agencyOnBehalfOfId && this.$store.state.user.user.onBehalfOfs.agencyOnBehalfOfId == -1) {
         this.agencyUser = false;
      } else {
         this.agencyUser = true;
      }
   },
   methods: {
      setUserSettingsObj(obj) {
         const self = this;
         self.userObj = obj;
      },
   },
   watch: {
      "$route.query.page": {
         handler: function (page) {
            this.profileSettings = false;
            this.userAuthorization = false;
            this.customerManagement = false;
            this.commissionDefinition = false;
            this.userSettings = false;
            switch (page) {
               case "profileSettings":
                  this.profileSettings = true;
                  break;
               case "userAuthorization":
                  this.userAuthorization = true;
                  break;
               case "customerManagement":
                  this.customerManagement = true;
                  break;
               case "userSettings":
                  this.userSettings = true;
                  break;
               case "commissionDefinition":
                  this.commissionDefinition = true;
                  break;
               default:
                  this.profileSettings = true;
                  break;
            }
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.settings-page-wrapper {
   .settings-page-inner {
      .settings-nav {
         display: flex;
         align-items: flex-start;
         justify-content: flex-start;

         .settings-nav-list {
            margin-left: 240px;
            padding-top: 16px;
            padding-bottom: 16px;
            width: 168px;
            border-radius: 16px;
            background: var(--gray-50) 0% 0% no-repeat padding-box;
            border: 1px solid var(--gray-200);
            /* box-shadow: 2px 2px 6px var(--gray-500-alpha-90); */
            box-shadow: var(--gts-box-shadow);

            .settings-nav-list-item {
               width: 100%;
               position: relative;
               display: flex;
               align-items: center;
               justify-content: flex-start;
               text-align: left;
               color: var(--gray-700);

               .settings-tabs-text {
                  font-size: var(--small);
               }

               & > i {
                  min-width: 32px;
                  margin-right: 8px;
               }

               &:hover {
                  background-color: var(--gray-100);
               }

               &.active {
                  background: none;

                  .settings-tabs-text {
                     font-weight: 600;
                  }

                  &::before {
                     content: "";
                     position: absolute;
                     width: 4px;
                     height: 75%;
                     left: 0;
                     background-color: var(--accent-primary);
                     border-top-right-radius: 12px;
                     border-bottom-right-radius: 12px;
                  }
               }
            }

            @media (max-width: 768px) {
               .settings-nav-list-item {
                  &.active {
                     background: none;

                     .settings-tabs-text {
                        font-weight: 600;
                     }
                     &::before {
                        content: "";
                        position: absolute;
                        width: 0px;
                        height: 0%;
                        left: 0;
                        background-color: var(--accent-primary);
                        border-top-right-radius: 0px;
                        border-bottom-right-radius: 0px;
                     }
                     &:after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        background-color: var(--accent-primary);
                        height: 2px;
                        left: -3px;
                        right: -3px;
                        width: 25%;
                     }
                  }
               }
            }

            @media (max-width: 992px) {
               .settings-nav-list-item {
                  &.active {
                     background: none;

                     .settings-tabs-text {
                        font-weight: 600;
                     }
                     &::before {
                        content: "";
                        position: absolute;
                        width: 0px;
                        height: 0%;
                        left: 0;
                        background-color: var(--accent-primary);
                        border-top-right-radius: 0px;
                        border-bottom-right-radius: 0px;
                     }
                     &:after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        background-color: var(--accent-primary);
                        height: 2px;
                        left: -3px;
                        right: -3px;
                        width: 25%;
                     }
                  }
               }
            }
         }

         @media (max-width: 768px) {
            .settings-nav-list {
               display: none;
            }
         }

         @media (max-width: 992px) {
            .settings-nav-list {
               display: none;
            }
         }

         .settings-nav-content-list {
            width: 55%;
            margin-left: 32px;
            background-color: var(--container-bg);
            border: 1px solid var(--gray-300);
            border-right: none;
            border-bottom: none;
            border-radius: 16px;
         }

         @media (max-width: 768px) {
            .settings-nav-content-list {
               width: 100%;
               margin-left: 8px;
               margin-right: 8px;
               background-color: var(--container-bg);
               border: 1px solid var(--gray-300);
               border-right: none;
               border-bottom: none;
               border-radius: 16px;
            }
         }

         @media (max-width: 992px) {
            .settings-nav-content-list {
               width: 100%;
               margin-left: 8px;
               margin-right: 8px;
               background-color: var(--surface-level-1);
               border: 1px solid var(--gray-300);
               border-right: none;
               border-bottom: none;
               border-radius: 16px;
            }
         }
      }

      @media (max-width: 768px) {
         .settings-nav {
            flex-direction: column;
         }
      }

      @media (max-width: 992px) {
         .settings-nav {
            flex-direction: column;
         }
      }
   }
}
.navbar-wrapper {
   margin-bottom: 0;
}
</style>
